import { z } from 'zod';
import { BILLING_TYPES, TRANSACTION_STATUSES } from '../enums.js';

const uuid = z.string().uuid().optional();

/** Filters for the Sessions list and its export. Dates are ISO times, from (inclusive) to (exclusive). */
export const sessionsQuery = z.object({
  from: z.string().datetime({ offset: true }).optional(),
  to: z.string().datetime({ offset: true }).optional(),
  status: z.enum([...TRANSACTION_STATUSES, 'all']).default('all'),
  organisationId: uuid,
  siteId: uuid,
  chargerId: uuid,
  driverId: uuid,
  billingType: z.enum(BILLING_TYPES).optional(),
  /** Driver, card, charger or place. */
  q: z.string().trim().max(100).optional(),
  sort: z.enum(['started', 'energy', 'duration']).default('started'),
  direction: z.enum(['asc', 'desc']).default('desc'),
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(25),
});
export type SessionsQuery = z.input<typeof sessionsQuery>;

export const SESSION_STATUS_LABELS: Record<(typeof TRANSACTION_STATUSES)[number], string> = {
  active: 'Charging',
  completed: 'Finished',
  aborted: 'Ended unexpectedly',
};

/**
 * CO2 kept out of the air by charging instead of driving a petrol car, in kg, the way the
 * old InfinityEV reports worked it out: the km the energy drives, times a petrol car's CO2
 * per km, times the share of the grid that's renewable.
 */
export function co2SavedKg(energyWh: number, f: { evWhPerKm: number; iceCo2GPerKm: number; gridRenewablesPercent: number }): number {
  const km = energyWh / f.evWhPerKm;
  return ((km * f.iceCo2GPerKm) / 1000) * (f.gridRenewablesPercent / 100);
}
